import type { AnyAction } from 'redux';
import * as Constants from 'constants/index';

export interface RowsState {
  rowsSelected: string[];
}

const initialState: RowsState = {
  rowsSelected: [],
};

export function RowsReducer(state: RowsState = initialState, action: AnyAction): RowsState {
  switch (action.type) {
    case Constants.CloudAdmin.ROWS.ROWS_SELECTED:
      return { ...state, rowsSelected: action.rowsSelectedIdsArray };
    case Constants.CloudAdmin.ROWS.CLEAR_ROWS_SELECTED:
      return { ...state, rowsSelected: [] };
    // A selection belongs to the list on screen, and this slice holds one array for all of
    // them. Users and Invites both key their header checkbox on the literal id 'master', so
    // selecting all in one left the other's header checked on arrival. Switching lists starts
    // a fresh selection, which is also what changing product tab already does - except that
    // one clears from the component, so only this switch was missed.
    case Constants.CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.SELECT_TOOL_BUTTON:
      return { ...state, rowsSelected: [] };
    default:
      return state;
  }
}
